import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  getCommodityPageList: ({commit}, data) => {
    pointsMailApi.getCommodityPageList(data)
      .then(result => {
        commit(types.POINTS_MAIL_LIST, result)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/store/actions.js